/**
 * EntityDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown, DropdownProps } from 'semantic-ui-react';

// Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { setCurrentEntityId } from '../../services/currentEntityId/actions';
// @ts-ignore
import { resetQueryString } from '../../services/router/actions';

// Selectors
// @ts-ignore
import { selectCurrentEntityId } from '../../services/currentEntityId/selectors';
// @ts-ignore
import { selectOptions } from './selectors';

interface OwnProps {
    direction?: 'left' | 'right';
    selection?: boolean;
    fluid?: boolean;
    inline?: boolean;
    entityTypeId: any;
}

interface StateProps {
    options: {
        key: number;
        text: string;
        value: number;
    }[];
    entityId?: string | string[];
}

interface DispatchProps {
    setCurrentEntityId: Function;
    resetQueryString: Function;
}

type Props = OwnProps & StateProps & DispatchProps;

export class EntityDropdown extends React.Component<Props> {
    handleChange = (
        event: React.SyntheticEvent<HTMLElement, Event>,
        data: DropdownProps
    ) => {
        this.props.resetQueryString();
        this.props.setCurrentEntityId(data.value);
    };

    render(): React.ReactElement {
        const {
            entityId,
            options,
            selection,
            fluid,
            inline,
            direction
        } = this.props;

        return (
            <Dropdown
                direction={direction}
                selection={selection}
                fluid={fluid}
                inline={inline}
                selectOnBlur={false}
                lazyLoad
                value={entityId}
                options={options}
                onChange={this.handleChange}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    StateProps
>({
    entityId: selectCurrentEntityId,
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { setCurrentEntityId, resetQueryString }
)(EntityDropdown);
